<template>
  <UiRadioTabsBase v-bind="{ ...$props, ...$attrs }" />
</template>

<script lang="ts">
import type { PropType } from 'vue'

interface IRadioTabOption {
  value: string
  text: string
}

export default {
  name: 'UiRadioTabs',
  inheritAttrs: false,
  props: {
    options: {
      type: Array as PropType<IRadioTabOption[]>,
      required: true as const,
    },
    modelValue: { type: String, required: true as const },
  },
}
</script>

<style>
@reference "../../globals/css/base.css";

.s-radio-tabs {
  @apply overflow-hidden rounded-md border border-border-subtle;

  .s-radio-tabs__tab {
    @apply bg-surface text-text-muted hover:bg-surface-muted;

    &.is-active {
      @apply bg-cta-bg text-cta-text;
    }

    & + .s-radio-tabs__tab {
      @apply border-l border-border-subtle;
    }
  }
}
</style>
